import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Icon from 'flarum/common/components/Icon';
/** Seconds between automatic slide changes. */
const ROTATE_MS = 10000;
/**
 * Promo banner slider: slide 1 = NEVERHACK shop, slide 2 = Steam account rental bot.
 * Every slide is a link; slides change every 10 s (paused while hovered), dots switch manually.
 * Texts and links are configured in Admin → Структура форума → Настройки.
 */
export default class NhBanner extends Component {
  index = 0;
  paused = false;
  slides() {
    const forum = app.forum;
    const read = (prefix, key, fallbackUrl) => {
      if (!forum.attribute(prefix + 'Enabled')) return null;
      return {
        key,
        url: String(forum.attribute(prefix + 'Url') || fallbackUrl),
        title: String(forum.attribute(prefix + 'Title') || ''),
        text: String(forum.attribute(prefix + 'Text') || ''),
        button: String(forum.attribute(prefix + 'Button') || ''),
        badges: String(forum.attribute(prefix + 'Badges') || '').split(',').map(s => s.trim()).filter(Boolean)
      };
    };
    return [read('nhBanner', 'shop', 'https://neverlakshack.com/'), read('nhBanner2', 'rent', 'https://t.me/NEVERRENTSHOP_bot')].filter(Boolean);
  }
  oncreate(vnode) {
    super.oncreate(vnode);
    this.startTimer();
  }

  /** (Re)starts the countdown, so a manually chosen slide stays for the full interval. */
  startTimer() {
    window.clearInterval(this.timer);
    this.timer = window.setInterval(() => {
      if (!this.paused && !document.hidden) this.show(this.index + 1);
    }, ROTATE_MS);
  }
  onremove(vnode) {
    super.onremove(vnode);
    window.clearInterval(this.timer);
  }

  /** Switches slides by toggling classes so the rest of the page is not redrawn. */
  show(i) {
    const el = this.element;
    if (!el) return;
    const slides = el.querySelectorAll('.NhBanner');
    if (slides.length < 2) return;
    this.index = (i + slides.length) % slides.length;
    slides.forEach((s, n) => s.classList.toggle('is-active', n === this.index));
    el.querySelectorAll('.NhBannerSlider-dot').forEach((d, n) => d.classList.toggle('is-active', n === this.index));
  }
  view() {
    const slides = this.slides();
    if (!slides.length) return null;
    if (this.index >= slides.length) this.index = 0;
    return m("div", {
      className: "NhBannerSlider",
      onmouseenter: () => this.paused = true,
      onmouseleave: () => this.paused = false
    }, slides.map((s, n) => this.slideView(s, n === this.index)), slides.length > 1 && m("div", {
      className: "NhBannerSlider-dots"
    }, slides.map((s, n) => m("button", {
      type: "button",
      className: 'NhBannerSlider-dot' + (n === this.index ? ' is-active' : ''),
      "aria-label": s.title,
      onclick: e => {
        e.redraw = false;
        this.show(n);
        this.startTimer();
      }
    }))));
  }
  slideView(s, active) {
    const rent = s.key === 'rent';
    const bare = s.url.replace(/^https?:\/\//, '').replace(/\/$/, '');
    const host = bare.startsWith('t.me/') ? bare : bare.replace(/\/.*$/, '');
    const emblem = app.forum.attribute('baseUrl') + '/assets/emblem.svg';
    return m("a", {
      key: s.key,
      className: 'NhBanner NhBanner--' + s.key + (active ? ' is-active' : ''),
      href: s.url,
      target: "_blank",
      rel: "noopener"
    }, m("div", {
      className: "NhBanner-grid",
      "aria-hidden": "true"
    }), m("div", {
      className: "NhBanner-glow",
      "aria-hidden": "true"
    }), m("div", {
      className: "NhBanner-body"
    }, m("div", {
      className: "NhBanner-top"
    }, m("span", {
      className: "NhBanner-brand"
    }, rent ? m(Icon, {
      name: "fab fa-steam",
      className: "NhBanner-emblem NhBanner-emblem--icon"
    }) : m("img", {
      className: "NhBanner-emblem",
      src: emblem,
      alt: ""
    }), m("span", {
      className: "NhBanner-brandName"
    }, "NEVER", m("b", null, rent ? 'RENT' : 'HACK')), m("span", {
      className: "NhBanner-host"
    }, host)), s.badges.length > 0 && m("span", {
      className: "NhBanner-badges"
    }, s.badges.map(b => m("span", {
      className: "NhBanner-badge"
    }, m(Icon, {
      name: "fas fa-check"
    }), " ", b)))), s.title && m("h2", {
      className: "NhBanner-title"
    }, s.title), s.text && m("p", {
      className: "NhBanner-text"
    }, s.text), s.button && m("span", {
      className: "NhBanner-button"
    }, s.button, " ", m(Icon, {
      name: rent ? 'fab fa-telegram-plane' : 'fas fa-arrow-right'
    }))), m("div", {
      className: "NhBanner-art",
      "aria-hidden": "true"
    }, rent ? m(Icon, {
      name: "fab fa-steam",
      className: "NhBanner-artIcon"
    }) : m("img", {
      src: emblem,
      alt: ""
    }), m("span", {
      className: "NhBanner-artLabel"
    }, rent ? '// RENT_02' : '// SHOP_01')));
  }
}
flarum.reg.add('neverhack-forum-nodes', 'forum/components/NhBanner', NhBanner);